import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function SplashScreen({ onComplete }) {
  const { t } = useTranslation();
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(onComplete, 500); // Wait for fade animation
    }, 2000); // Show splash for 2 seconds

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="splash-content">
        <img 
          src="/assets/icon.png" 
          alt="PureBite Halal" 
          className="splash-logo"
        />
        <h1 className="splash-title">PureBite Halal</h1>
        <p className="splash-subtitle">{t('splash.subtitle', { defaultValue: 'Your Trusted Halal Food Companion' })}</p>
        <div className="splash-loader">
          <div className="loader-dot"></div>
          <div className="loader-dot"></div>
          <div className="loader-dot"></div>
        </div>
      </div>
    </div>
  );
}
